<div class="stripe-pricing-table-container" [ngClass]="{'large-screen': isLargeScreen$()}">
    <!-- PROD -->
     @if(scriptLoaded) {
        <stripe-pricing-table pricing-table-id="prctbl_1QDkXz2MyGE6iSkWjCn9bQz9"
            publishable-key="pk_live_51Pl6Dp2MyGE6iSkWtk0wIZFm8JEgFQEuvCpofEucC2jzcnpj25vYhdQ1rF5YkMWtqha5dU6LDu17E26UHaMkAwS700Z5goGjgB"
            [attr.client-reference-id]="shopId()">
        </stripe-pricing-table>
    
        <!-- TEST -->
        <!-- <stripe-pricing-table pricing-table-id="prctbl_1QfNWj2MyGE6iSkW72GavKmT"
            publishable-key="pk_test_51Pl6Dp2MyGE6iSkWZ0S9AaaQgMNiFvInv3YK7HGCJHooGSEkyQtbsC9cZBALHjtg0XWr2swsKRjy6RAjQkj7kw9z00bxR4F8om"
            [attr.client-reference-id]="shopId()">
        </stripe-pricing-table> -->
    }
</div>
